import {createAction, props} from "@ngrx/store";
import {PlanetResource} from "../../models/PlanetResource";

export const UPDATE = '[Resource] Update';
export const REFRESH = '[Resource] Init';
export const update = createAction(UPDATE, props<{ planetResources: PlanetResource[] }>());
export const refresh = createAction(REFRESH);
